var _path, _g, _g2, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSalesPilotLogoSmall = function SvgSalesPilotLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.838 22.499h-4.93c0-9.678-7.847-17.55-17.492-17.55V0c12.363 0 22.423 10.092 22.423 22.499z",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.415 45.001v-4.947c9.645 0 17.491-7.873 17.491-17.55h4.93c0 12.405-10.058 22.498-22.422 22.498z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.415 45.001v-4.947c9.645 0 17.491-7.873 17.491-17.55h4.93c0 12.405-10.058 22.498-22.422 22.498z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.856 22.503h-4.93c0-9.639 7.884-17.55 17.49-17.55V9.9c-6.886 0-12.559 5.692-12.559 12.602"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.856 22.503h-4.93c0-9.639 7.884-17.55 17.49-17.55V9.9c-6.886 0-12.559 5.692-12.559 12.602"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.416 40.052v-4.97c6.886 0 12.559-5.669 12.559-12.578h4.93a17.474 17.474 0 0 1-17.489 17.55z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.905 22.498h-4.93c0-6.91-5.673-12.602-12.559-12.602V4.95c9.702.032 17.49 7.912 17.49 17.55z",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.423 44.999C10.058 44.999 0 34.906 0 22.5h4.93c0 9.678 7.847 17.551 17.492 17.551v4.947",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.306 38.856a2.057 2.057 0 0 0 2.054-2.06c0-1.139-.92-2.062-2.054-2.062a2.057 2.057 0 0 0-2.054 2.061c0 1.138.92 2.061 2.054 2.061M17.591 38.81a2.057 2.057 0 0 0 2.054-2.062c0-1.138-.92-2.06-2.054-2.06a2.057 2.057 0 0 0-2.054 2.06c0 1.139.92 2.061 2.054 2.061M34.967 22.51c0 6.868-5.594 12.574-12.44 12.574S9.786 29.494 9.786 22.626c0-1.934.451-3.82 1.29-5.523H.675a22.6 22.6 0 0 1 1.867-4.947h14.664v4.952a7.48 7.48 0 0 0-2.433 5.518c0 4.11 3.658 7.456 7.756 7.456s7.455-3.464 7.455-7.572c.1.024 4.943-.035 4.985 0z"
  })));
};
export { SvgSalesPilotLogoSmall as ReactComponent };
export default "/_next/static/media/src/components/Layouts/AppLayout/Sidebar/assets/salesPilotLogoSmall.c2206c4d2117a9fd558784a9a7f588cc.svg";